// Product Categories
export const productCategories = [
  {
    id: 1,
    title: "Loans",
    description: "Comprehensive loan solutions tailored to your financial needs",
    icon: "briefcase",
    path: "/loans"
  },
  {
    id: 2,
    title: "Portfolio Management",
    description: "Expert investment management services for wealth creation",
    icon: "trending-up",
    path: "/portfolio-management"
  },
  {
    id: 3,
    title: "Insurance",
    description: "Protect what matters most with comprehensive insurance coverage",
    icon: "shield",
    path: "/insurance"
  }
];

// Loan Products
export const loanProducts = [
  { id: 1, name: "Home Loan", path: "/loans/home-loan" },
  { id: 2, name: "Loan Against Property", path: "/loans/lap" },
  { id: 3, name: "Personal Loan", path: "/loans/personal-loan" },
  { id: 4, name: "Business Loan", path: "/loans/business-loan" },
  { id: 5, name: "Working Capital", path: "/loans/working-capital" },
  { id: 6, name: "Car Loan", path: "/loans/car-loan" },
  { id: 7, name: "Education Loan", path: "/loans/education-loan" },
  { id: 8, name: "Education Infrastructure Loan", path: "/loans/education-infra-loan" }
];

// Portfolio Management Products
export const portfolioProducts = [
  { id: 1, name: "PMS", fullName: "Portfolio Management Services", path: "/portfolio-management/pms" },
  { id: 2, name: "AIF", fullName: "Alternative Investment Funds", path: "/portfolio-management/aif" },
  { id: 3, name: "Mutual Funds", path: "/portfolio-management/mutual-funds" },
  { id: 4, name: "Unlisted Shares", path: "/portfolio-management/unlisted-shares" },
  { id: 5, name: "Others", path: "/portfolio-management/others" }
];

// Insurance Products
export const insuranceProducts = [
  { id: 1, name: "Life Insurance", path: "/insurance/life" },
  { id: 2, name: "Health Insurance", path: "/insurance/health" },
  { id: 3, name: "General Insurance", path: "/insurance/general" }
];

// Lending Partners
export const lendingPartners = {
  banks: [
    { id: 1, name: "State Bank of India" },
    { id: 2, name: "HDFC Bank" },
    { id: 3, name: "ICICI Bank" },
    { id: 4, name: "Axis Bank" },
    { id: 5, name: "Kotak Mahindra Bank" },
    { id: 6, name: "Punjab National Bank" }
  ],
  nbfcs: [
    { id: 1, name: "Bajaj Finserv" },
    { id: 2, name: "Tata Capital" },
    { id: 3, name: "Mahindra Finance" },
    { id: 4, name: "L&T Finance" },
    { id: 5, name: "Poonawalla Fincorp" },
    { id: 6, name: "IIFL Finance" }
  ],
  others: [
    { id: 1, name: "LIC Housing Finance" },
    { id: 2, name: "HDFC Ltd" },
    { id: 3, name: "PNB Housing Finance" },
    { id: 4, name: "Indiabulls Housing Finance" },
    { id: 5, name: "Can Fin Homes" },
    { id: 6, name: "Repco Home Finance" }
  ]
};

// Company Stats
export const stats = [
  { 
    id: 1, 
    value: "527+", 
    label: "Cities",
    icon: "map-pin"
  },
  { 
    id: 2, 
    value: "500+", 
    label: "Branches",
    icon: "building"
  },
  { 
    id: 3, 
    value: "5k+", 
    label: "Employees",
    icon: "users"
  },
  { 
    id: 4, 
    value: "25k+", 
    label: "Financial Advisors",
    icon: "user-check"
  },
  { 
    id: 5, 
    value: "180+", 
    label: "Lending Partners",
    icon: "handshake"
  }
];